import api from '../../helpers/axios'

export const state = {
    bankPayment: null,
    bankPayments: []
};

export const getters = {
    bankPayment: (state) => state.bankPayment,
    bankPayments: (state) => state.bankPayments,
};

export const mutations = {
    setBankPayment(state, newValue) {
        state.bankPayment = newValue;
    },
    setBankPayments(state, newValue) {
        state.bankPayments = newValue;
    },
};

export const actions = {
    createBankPayment(_, data) {
        return new Promise((resolve, reject) => {
            api.post("/bank-payments", data).then((res) => {
                if (res) {
                    resolve(res.data.data)
                }
            }).catch((err) => {
                reject(err)
            })
        });
    },
    updateBankPayment(_, {id, data}) {
        return new Promise((resolve, reject) => {
            api.put("/bank-payments/" + id, data).then((res) => {
                resolve(res.data.data);
            }).catch((err) => {
                reject(err);
            });
        });
    },
    updateBankPaymentMulti(_, {data}) {
        return new Promise((resolve, reject) => {
            api.put("/bank-payments-multi", data).then((res) => {
                resolve(res.data.data);
            }).catch((err) => {
                reject(err);
            });
        });
    },
    laterBankPayment(_, {id, data}) {
        return new Promise((resolve, reject) => {
            api.put("/bank-payments/" + id + "/later", data).then((res) => {
                resolve(res.data.data);
            }).catch((err) => {
                reject(err);
            });
        });
    },
    
    deleteBankPayment(_, id) {
        return new Promise((resolve) => {
            api.delete("/bank-payments/" + id).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    deletesBankPayment() {
        return new Promise((resolve) => {
            api.delete("/bank-payments").then((res) => {
                resolve(res.data.data)
            })
        });
    },

    fetchBankPayments({commit}, {page, limit,  search}) {
        let query = "?";
        
        query += `page=${page}&`;
        query += `limit=${limit}&`;
        
        if (search) {
            query += `q=${search}&`;
        }

        return new Promise((resolve) => {
            api.get("/bank-payments" + query).then((res) => {
                commit("setBankPayments", res.data.data);
                resolve(res.data.data);
            });
        });
    },
};
